import React from "react";
import { StatusBar } from "react-native";

import { BackButton, EStyleSheetManager, NetworkListener } from "utils";
import Router, { ProtectedRoute } from "router";
import State from "state";

import { styles } from "./styles";

const App = () => (
  <State>
    <StatusBar hidden />
    <BackButton disabled />
    <EStyleSheetManager globals={styles} />
    <NetworkListener />
    <ProtectedRoute>
      <Router />
    </ProtectedRoute>
  </State>
);

export default App;
